import { unFormatCurrency } from '@/common/utils/unFormatters';
import { UpdateExecutionEntryEstablishmentAcceptValidationSchema } from '@/features/maintenance/features/workflows/features/executionEntry/schemas/updateExecutionEntryEstablishmentAccept.schema';
import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { AuctionEntryDirectiveObjectiveData } from '../../../../../types/auctionEntry.type';
import ProposalGroupHeader from '../ProposalGroupHeader';
import ActivityRow from './ActivityRow';

interface ExecutionObjectiveActivitiesProps {
  executionObjective: AuctionEntryDirectiveObjectiveData
  activityStartIndex: number
}

const ExecutionObjectiveActivities = ({
  executionObjective,
  activityStartIndex,
}: ExecutionObjectiveActivitiesProps) => {
  const { control } = useFormContext<UpdateExecutionEntryEstablishmentAcceptValidationSchema>();

  const formActivities = useWatch({ control, name: 'activities' });

  const activitiesCountDisplay = useMemo(() => {
    const count = executionObjective.execution_activities?.length || 0

    if (count === 0) {
      return 'Nenhum serviço'
    }

    if (count === 1) {
      return '1 Serviço'
    }

    return `${count} Serviços`
  }, [executionObjective.execution_activities?.length])

  const totalValueSum = useMemo(() => {
    return (
      executionObjective.execution_activities?.reduce((prev, curr, index) => {
        const fieldIndex = activityStartIndex + index
        const formActivity = formActivities?.[fieldIndex]
        const originalUnitPrice = Number(curr.unit_price) || 0
        const quantity = Number(curr.quantity) || 0

        const newUnitPriceNumber = formActivity?.new_unit_price ? unFormatCurrency(formActivity.new_unit_price) : null

        if (newUnitPriceNumber !== null && newUnitPriceNumber !== originalUnitPrice) {
          return prev + newUnitPriceNumber * quantity
        }

        return prev + (Number(curr.total_value) || 0)
      }, 0) || 0
    )
  }, [formActivities, executionObjective.execution_activities, activityStartIndex])

  return (
    <div className="flex flex-col gap-2">
      <ProposalGroupHeader
        title="Serviços"
        countDisplay={activitiesCountDisplay}
        totalValueSum={totalValueSum}
      />

      <div className="flex flex-col gap-3">
        {executionObjective.execution_activities?.map((executionActivity, index) => {
          const fieldIndex = activityStartIndex + index

          return (
            <ActivityRow
              key={executionActivity.id}
              executionActivity={executionActivity}
              fieldIndex={fieldIndex}
            />
          );
        })}
      </div>
    </div>
  );
}

export default ExecutionObjectiveActivities
